import React, { useEffect, useState } from 'react';
import type { QuestionRendererProps } from './types';
import { MapCanvas } from '../../../visuals/components/topoMap/MapCanvas';
import { FALLBACK_COLOR } from './rendererUtils';
import { useEdgeTriggeredSubmit } from './useEdgeTriggeredSubmit';
/**
 * MapLocateRegionRenderer — Click on a region (province / country / continent)
 * to answer.
 *
 * Answer payload: string regionId (e.g. "NL-LI").
 * Validator: validateMapLocateRegion in mapValidators.ts.
 *
 * Submit pattern: emits onAnswer once when shouldValidate flips to true
 * (driven by the global "Controleren" button in PracticeSession).
 * No internal submit button — avoids duplicate UI.
 */
export function MapLocateRegionRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate,
  moduleColor
}: QuestionRendererProps) {
  const color = moduleColor || FALLBACK_COLOR;
  const data = (question.data ?? {}) as Record<string, unknown>;
  const mapId = String(data.mapId ?? '');
  const showFirstLetterHint = data.showFirstLetterHint === true;
  const regionNoun = typeof data.regionNoun === 'string' ? data.regionNoun as string : mapId === 'nl-islands' ? 'eiland' : mapId.startsWith('eu-') ? 'land' : 'provincie';
  const [selectedRegionId, setSelectedRegionId] = useState<string | null>(null);
  useEffect(() => {
    setSelectedRegionId(null);
  }, [question.id]);
  useEffect(() => {
    onReadyChange?.(selectedRegionId !== null);
  }, [selectedRegionId, onReadyChange]);
  useEdgeTriggeredSubmit(selectedRegionId ?? '', shouldValidate, onAnswer, question.id);
  return <div className="flex flex-col items-center gap-3 w-full" data-id="element-10621">
      <MapCanvas mapId={mapId} mode="select-region" selectedRegionId={selectedRegionId} onRegionSelect={setSelectedRegionId} showFirstLetterHint={showFirstLetterHint} highlightStyle="primary" width={420} height={420} ariaLabel={question.question} moduleColor={color} data-id="element-10622" />

      <p className="text-sm text-stone-500 flex items-center gap-1.5 min-h-[1.25rem]" aria-live="polite" data-id="element-10623">
        {selectedRegionId ? <>
            <span className="inline-block w-2 h-2 rounded-full" style={{
          backgroundColor: color
        }} aria-hidden="true" data-id="element-10624" />
            Klik op een ander {regionNoun} om te wisselen
          </> : <span className="text-stone-400" data-id="element-10625">Klik op een {regionNoun}</span>}
      </p>
    </div>;
}